var TopicType = require('../../../topics/topics').TopicType;
var DataTypes = require('data/datatypes');
var schema = require('schema/schema');
var util = require('metadata/util');

module.exports.deriveDetails = function(value) {
    var details = {};

    for (var t in TopicType) {
        if (TopicType[t] === value) {
            return {
                type : value
            };
        }
    }

    if (util.isMetadataValue(value)) {
        var meta = util.deriveMetadata(value);

        details.type = util.getType(meta);
        details.schema = schema(meta);
    } else {
        var datatype = DataTypes.get(value);

        details.type = TopicType[datatype.name().toUpperCase()];
        details.schema = {};
        details.content = datatype.from(value);
    }

    return details;
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/topics/details/topic-details.js
// module id = 1048
// module chunks = 1